import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

const getApplicationAccessUserDetails = (
  userId,
  fromDate,
  toDate,
  timeZone,
  reportMode
) => {
  if (reportMode === "View") {
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.ACCESS_REPORT.GET_APPLICATION_ACCESS_USER_DETAILS(
        userId,
        fromDate,
        toDate,
        timeZone,
        reportMode
      ),
      ""
    );
  } else {
    let url =
      encodeURIComponent(apiConstants.BASE_URL_1) +
      encodeURIComponent(
        apiConstants.REPORT.ACCESS_REPORT.GET_APPLICATION_ACCESS_USER_DETAILS(
          userId,
          fromDate,
          toDate,
          timeZone,
          reportMode
        )
      );
    let template = "QuizPerformanceReport";
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.CSV_REPORT(url, template),
      ""
    );
  }
};

export default getApplicationAccessUserDetails;
